import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CalendarProps } from "@/components/ui/calendar";
import { DatePicker } from "@/components/ui/date-picker";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { cn } from "@/lib/utils";

interface MezzaDatePickerProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  shouldDisableDate?: (date: Date) => boolean;
  calendarProps?: Omit<CalendarProps, 'mode' | 'selected' | 'onSelect' | 'disabled' | 'initialFocus'>;
  className?: string;
  triggerClassName?: string;
}

export function MezzaDatePicker<T extends FieldValues>({
  form,
  name,
  label,
  placeholder,
  disabled = false,
  shouldDisableDate,
  calendarProps,
  className,
  triggerClassName,
}: MezzaDatePickerProps<T>) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn("flex flex-col", className)}>
          <FormLabel>{t(label)}</FormLabel>
          <FormControl>
            <DatePicker
              value={field.value as Date | undefined}
              onSelect={field.onChange}
              placeholder={placeholder}
              disabled={disabled}
              shouldDisableDate={shouldDisableDate}
              calendarProps={calendarProps}
              className={triggerClassName}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
} 